import { Button, Textarea } from '@chakra-ui/react'
import styled from '@emotion/styled'

export const SearchTextarea = styled(Textarea)`
    background: var(--chakra-colors-input2);
    width: 100%;
    height: 20vh;
    max-width: 1300px;
    min-width: 300px;
    white-space: pre;
    border-radius: 3px;
    border: 1px solid transparent;
    font-family: Roboto Mono, serif;
    font-size: 14px;
    padding: 1em;
`

export const ParseBtn = styled(Button)`
    background: ${({ theme }) =>
        //@ts-ignore TODO: theme type defiinition
        theme.colors.chronicle.ultramarine};
    font-weight: 500;
    border-radius: 1px;
`

export const SampleBtn = styled(Button)`
    font-weight: 500;
    border: 3px solid white;
    border-radius: 1px;
    background: transparent;
`

export const SearchTitle = styled.div`
    text-align: left;
    font-size: 32px;
    font-weight: 500;
    margin-bottom: 0.5em;
`
